<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button v-if="access.elements.actionCrud" variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar empleado" aria-label="Agregar empleado" @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 260px; max-width: 340px;">
              <label class="filter-label">Buscar</label>
              <b-form-input type="text" size="sm" placeholder="Nombre, teléfono o email" v-model="table.filter" />
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(image)="data">
                  <b-avatar :src="data.item.staff.image"
                            v-if="data.item.staff.image">
                  </b-avatar>
                  <b-avatar v-else
                            :text="avatarFromName(data.item.name).text"
                            :style="avatarFromName(data.item.name).style">
                  </b-avatar>                                  
                </template>

                <template v-slot:cell(way_working)="data">
                  <div v-if="data.item.way_working=='hours'">
                    <b>{{ data.item.hours }} Hs.</b> Diarias
                  </div>
                  <div v-if="data.item.way_working=='projects'">
                    <b>Por Proyecto</b>
                  </div>
                  <div v-if="data.item.way_working=='account'">
                    <b>Por Cuenta</b>
                  </div>                                    
                </template>

                <template v-slot:cell(salary)="data">
                  <div v-if="access.elements.showSalary">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.salary)}}                  
                  </div>
                  <div v-else>
                    -
                  </div>                  
                </template>      

                <template v-slot:cell(category_id)="data">
                  <b>{{ data.item.category.id }}</b> - {{data.item.category.name}}
                </template>                

                <template v-slot:cell(active)="data">
                  <div v-if="data.item.active">
                    <b-badge variant="success">Activo</b-badge>                    
                  </div>
                  <div v-else>
                    <b-badge variant="danger">Inactivo</b-badge>                    
                  </div>
                </template>

                <template v-slot:cell(permission_admin_projects)="data">
                  <div v-if="data.item.permission_admin_projects">
                    <b-badge variant="warning">SI</b-badge>                    
                  </div>
                </template>

                <template v-slot:cell(access)="data">
                  <b-button size="sm"
                            variant="outline-secondary"
                            v-if="data.item.staff && data.item.staff.user_id"
                            @click="viewAccess(data.item)">
                    <AppIcon name="visibility" class="mr-1" />Ver acceso
                  </b-button>
                  <span v-else class="text-muted small">Sin usuario</span>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-employee-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="irDetailHours(data.item)">
                      <AppIcon name="history" /> Horarios
                    </b-dropdown-item>                          
                    <b-dropdown-header v-if="access.elements.actionCrud">
                      Acciones
                    </b-dropdown-header>                    
                    <b-dropdown-item @click="edit(data.item)" v-if="access.elements.actionCrud">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="access.elements.actionCrud">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="people" title="No se encontraron empleados" />
            <div class="app-table-footer">
              <span class="list-view-toolbar__count">{{ getRowCount(table.items) }} registros</span>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <div>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="arrow_back" class="mr-1" />
              Volver
            </b-button>                        
          </div>

          <nav>
              <b-pagination class="mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>
      

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="people" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
          <b-tab active>
            <template #title><AppIcon name="description" class="mr-1" /> General</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.active" 
                                  switch 
                                  size="sm" 
                                  class="mt-4 pull-right">
                  Activo
                </b-form-checkbox>            
              </b-col>     
                        
              <b-col md="12">
                <FindObject type="staff" 
                            @select-object="loadStaff($event)" 
                            :valueID="crud.form.staff_id"/>
              </b-col>

              <b-col md="12">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre">
                  </b-form-input>
                </b-form-group>
              </b-col>       

              <b-col md="12">
                <b-form-group label="Teléfono">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.phone"
                                required
                                placeholder="Ej: 5493416908870 (13 dígitos)">
                  </b-form-input>
                </b-form-group>
              </b-col> 

              <b-col md="12">
                <b-form-group label="Email">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.email"
                                required
                                placeholder="Ingresar un email">
                  </b-form-input>
                </b-form-group>
              </b-col> 
            </b-row>
          </b-tab>
          <b-tab>
            <template #title><AppIcon name="payments" class="mr-1" /> Arreglo Comercial</template>
            <b-row>
              <b-col md="12">
                <FindObject type="employeeCategory" 
                            @select-object="loadEmployeeCategory($event)" :valueID="crud.form.category_id"/>
              </b-col>                                                    

              <b-col md="12">
                <b-form-group label="Formas de Contratación"
                              description="El precio es aplicado según la forma de contratación.">
                  <b-form-select v-model="crud.form.way_working" 
                                :options="arr.select.way_working"
                                stacked
                                @input="changeWayWorking()">
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4" v-if="crud.form.way_working=='hours'">
                <b-form-group label="Horas Diarias">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.hours"                            
                                placeholder="Ingresar las horas diarias de trabajo">
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="8">
                <b-form-group label="Salario" :description="alerts.salary_input">
                  <app-number-input size="sm"
                                    v-model="crud.form.salary"
                                    placeholder="Ingresar el sueldo mensual" />
                </b-form-group>
              </b-col>          
            </b-row>
          </b-tab>
          <b-tab>
            <template #title><AppIcon name="admin_panel_settings" class="mr-1" /> Permisos</template>
            <b-row>
              <b-col md="12">
                <b-form-checkbox v-model="crud.form.permission_admin_projects" 
                                  switch 
                                  size="sm" 
                                  class="mt-4 pull-right">
                  Permite visualizar todos los proyectos como un perfil Administrador
                </b-form-checkbox>            
              </b-col>               
            </b-row>
          </b-tab>
        </b-tabs>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- ACCESO DEL USUARIO VINCULADO AL STAFF -->
      <b-modal v-model="modal.password.active">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{modal.password.title}}</h5>
        </div>

        <b-row>
          <b-col>
            <b-input-group class="w-100 mb-1">
              <b-input-group-append>
                <div class="input-group-text"><AppIcon name="person-fill" /></div>
              </b-input-group-append>
              <b-form-input type="text" size="md" v-model="crud.password.email" readonly />
            </b-input-group>

            <b-input-group class="w-100">
              <b-form-input :type="crud.password.typePassword" size="md" v-model="crud.password.password" readonly />
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="changeTypePassword()">
                  <AppIcon :name="crud.password.iconPassword" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="pull-right" @click="modal.password.active = false">Cerrar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Funciones from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },    
    data: () => {
      return {      
        access: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudEmployee',
          elements: {
            actionCrud: true,
            showSalary: true,            
          }
        }, 
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        crud: {
          form: {
            id: 0,
            name: '',
            phone: '',
            email: '',            
            staff: null,
            staff_id: 0,
            category: null,
            category_id: 0,
            hours: 0,
            salary: 0,            
            active: true,   
            way_working: 'hours',
            permission_admin_projects: false,
          },          
          password: {
            name: '',
            email: '',
            password: '',
            typePassword: 'password',
            iconPassword: 'visibility',
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          password: {
            active: false,
            title: '',
          },
        },
        arr: {          
          select: {
            way_working: [              
              { value: 'hours', text: 'Por Horas Diarias' },         
              { value: 'projects', text: 'Por Proyectos' },                                 
              { value: 'account', text: 'Por Cuentas' },   
            ],
          }
        },
        alerts: {
          salary_input: 'El salario corresponde al mes completo.'
        }                        
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.actionCrud = Helper.hasAccessElement(this.access, 'action_crud')
      this.access.elements.showSalary = Helper.hasAccessElement(this.access, 'show_salary')      
      /* Fin configuracion */
    }, 
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_crud_employee', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.setFields()
      },
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_employee') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.setFields()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      setFields() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
          {key: 'image', label: 'Perfil', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'name', label: 'Nombre', class: 'align-middle'},
          {key: 'phone', label: 'Teléfono', class: 'align-middle'},
          {key: 'email', label: 'Email', class: 'align-middle'},
          {key: 'access', label: 'Acceso', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'category_id', label: 'Categoría', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'way_working', label: 'Forma de contratación', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'salary', label: 'Salario', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'active', label: 'Estado', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'permission_admin_projects', label: 'Admin. proyectos', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'f_action', label: this.isMobileViewport ? 'Acciones' : '', class: 'align-middle ' + this.alignClass('text-center')},
        ]
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerEmpleado()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      loadEmployeeCategory (object) {
        if(object){
          this.crud.form.category = object
          this.crud.form.category_id = object.id
        } else {
          this.crud.form.category = null
          this.crud.form.category_id = 0
        }
      },      
      loadStaff (object) {
        if(object){
          if(this.crud.form.staff_id != object.id) {
            this.crud.form.staff = object
            this.crud.form.staff_id = object.id
            this.crud.form.name = object.name
            this.crud.form.phone = object.phone
            this.crud.form.email = object.email            
          }
        } else {
          this.crud.form.staff = null
          this.crud.form.staff_id = 0
          this.crud.form.name = ''
          this.crud.form.phone = ''
          this.crud.form.email = ''           
        }
      },            
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''    
        this.crud.form.staff_id = 0
        this.crud.form.staff = null
        this.crud.form.category_id = 0
        this.crud.form.category = null
        this.crud.form.phone = ''
        this.crud.form.email = ''
        this.crud.form.hours = 0 
        this.crud.form.salary = 0         
        this.crud.form.active = true
        this.crud.form.way_working = 'hours'
        this.crud.form.permission_admin_projects = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Empleado"
        this.modal.form.active = true
      },
      edit(item) {        
        this.crud.form.id = item.id
        this.crud.form.name = item.name   
        this.crud.form.staff_id = item.staff.id   
        this.crud.form.staff = item.staff   
        this.crud.form.category_id = item.category.id   
        this.crud.form.category = item.category
        this.crud.form.phone = item.phone
        this.crud.form.email = item.email
        this.crud.form.hours = item.hours
        this.crud.form.salary = item.salary             
        this.crud.form.active = item.active
        this.crud.form.way_working = item.way_working
        this.crud.form.permission_admin_projects = item.permission_admin_projects

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Empleado"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Empleado',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarEmpleado(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        // valida que tenga el formato correcto para emails
        if(this.crud.form.email) {
          var expreg = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$")
          if (!expreg.test(this.crud.form.email)) {          
            this.$awn.alert("El email no posee un formato válido")          
            return false
          }       
        }

        // valida que tenga el formato para whatsapp
        if(this.crud.form.phone) {
          if(!Funciones.validarTelefonoWhatsapp(this.crud.form.phone)) {
            this.$awn.alert("El nro de télefono no posee un formato válido para Whatsapp")
            return false
          }
        }

        let loader = this.$loading.show();
        var result = this.crud.form.id
          ? serviceAPI.editarEmpleado(this.crud.form)
          : serviceAPI.agregarEmpleado(this.crud.form)

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      changeWayWorking() {        
        if(this.crud.form.way_working == 'hours') {
          this.alerts.salary_input = 'El salario corresponde al mes completo.'
          this.crud.form.hours = 0
        }

        if(this.crud.form.way_working == 'projects') {
          this.alerts.salary_input = 'El salario corresponde a lo cobrado por proyecto.'
          this.crud.form.hours = 0
        }

        if(this.crud.form.way_working == 'account') {
          this.alerts.salary_input = 'El salario corresponde a lo cobrado por cada cuenta.'
          this.crud.form.hours = 0
        }        
      },
      irDetailHours(data) {        
        this.$router.push({ name: 'EmployeeStaffDetailHours', params: { employeeID: data.id } })                  
      },
      // El empleado utiliza las credenciales del usuario vinculado a su staff,
      // igual que la gestión de vendedores.
      viewAccess(item) {
        this.crud.password.name = item.name
        this.crud.password.email = item.staff.user.email
        this.crud.password.password = item.staff.user.password_visible
        this.crud.password.typePassword = 'password'
        this.crud.password.iconPassword = 'visibility'

        this.modal.password.title = 'Accesos --> ' + this.crud.password.name
        this.modal.password.active = true
      },
      changeTypePassword() {
        if (this.crud.password.typePassword === 'password') {
          this.crud.password.typePassword = 'text'
          this.crud.password.iconPassword = 'visibility_off'
        } else {
          this.crud.password.typePassword = 'password'
          this.crud.password.iconPassword = 'visibility'
        }
      },
    }     
  }
</script>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }

  .btn.crud-employee-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }

  .btn.crud-employee-action-toggle-labeled:hover,
  .btn.crud-employee-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }

  @media (max-width: 767.98px) {
    .app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
